import buildQuery from '../utils/router/buildQuery';
import { ApiClientInterface } from './clients';
import { UuidResult } from './models';
import { Comment } from './models';
import { CommentListResult } from './models/project/common/CommentListResult';

export class CommentManager {
  constructor(private readonly apiClient: ApiClientInterface) {}

  public async getList(
    projectUuid: string,
    page: number,
    perPage: number
  ): Promise<CommentListResult> {
    const query = buildQuery({ page, perPage });
    return this.apiClient.get(`/${projectUuid}?${query}`);
  }

  public async create(
    projectUuid: string,
    text: string,
    parentUuid?: string,
    scope?: string,
    targetUserUuid?: string
  ): Promise<UuidResult> {
    const payload: any = { text };
    if (parentUuid) {
      payload.parentUuid = parentUuid;
    }
    if (scope) {
      payload.scope = scope;
    }
    if (targetUserUuid) {
      payload.targetUserUuid = targetUserUuid;
    }
    return this.apiClient.post(`/${projectUuid}`, payload);
  }

  public async getOne(commentUuid: string): Promise<Comment> {
    return this.apiClient.get(`/comment/${commentUuid}`);
  }
}
